'use client'

import { useContext } from 'react'
import { AnalyticsContext } from '@/context/analyticsContext'

export function useAnalytics() {
    const { analytics } = useContext(AnalyticsContext)

    return {
        // Navigation & Global Actions
        trackNavItemClick: analytics.trackNavItemClick.bind(analytics),

        // Authentication
        trackLoginClick: analytics.trackLoginClick.bind(analytics),
        trackSignupClick: analytics.trackSignupClick.bind(analytics),
        trackMagicLinkSendClick:
            analytics.trackMagicLinkSendClick.bind(analytics),

        // Landing Page Creation
        trackAIWizardStartClick:
            analytics.trackAIWizardStartClick.bind(analytics),
        trackAIWizardAdSelect: analytics.trackAIWizardAdSelect.bind(analytics),
        trackAIWizardPersonaSelect:
            analytics.trackAIWizardPersonaSelect.bind(analytics),
        trackAIWizardProductSelect:
            analytics.trackAIWizardProductSelect.bind(analytics),
        trackAIWizardLayoutSelect:
            analytics.trackAIWizardLayoutSelect.bind(analytics),
        trackAIWizardGenerateClick:
            analytics.trackAIWizardGenerateClick.bind(analytics),
        trackLandingPageCopyLinkClick:
            analytics.trackLandingPageCopyLinkClick.bind(analytics),
        trackLandingPagePreviewClick:
            analytics.trackLandingPagePreviewClick.bind(analytics),
        trackLandingPageEditClick:
            analytics.trackLandingPageEditClick.bind(analytics),

        // Content Blocks
        trackContentBlockAdd: analytics.trackContentBlockAdd.bind(analytics),
        trackContentBlockEdit: analytics.trackContentBlockEdit.bind(analytics),
        trackContentBlockDelete:
            analytics.trackContentBlockDelete.bind(analytics),

        // Video Management
        trackVideoUploadClick: analytics.trackVideoUploadClick.bind(analytics),
        trackVideoSaveClick: analytics.trackVideoSaveClick.bind(analytics),
        trackVideoDeleteClick: analytics.trackVideoDeleteClick.bind(analytics),

        // Product Management
        trackProductImportClick:
            analytics.trackProductImportClick.bind(analytics),
        trackProductClick: analytics.trackProductClick.bind(analytics),
        trackProductImportFromShopifyClick:
            analytics.trackProductImportFromShopifyClick.bind(analytics),

        // Link Management
        trackLinkCreateClick: analytics.trackLinkCreateClick.bind(analytics),
        trackLinkEditClick: analytics.trackLinkEditClick.bind(analytics),
        trackLinkCopyClick: analytics.trackLinkCopyClick.bind(analytics),

        // Persona Management
        trackPersonaCreateClick:
            analytics.trackPersonaCreateClick.bind(analytics),
        trackPersonaEditClick: analytics.trackPersonaEditClick.bind(analytics),
        trackPersonaGenerateClick:
            analytics.trackPersonaGenerateClick.bind(analytics),

        // Settings
        trackSettingsTabClick: analytics.trackSettingsTabClick.bind(analytics),
        trackSettingsSaveClick:
            analytics.trackSettingsSaveClick.bind(analytics),
        trackSettingsFontChange:
            analytics.trackSettingsFontChange.bind(analytics),
        trackBrandColorChange: analytics.trackBrandColorChange.bind(analytics),
        trackBrandFontChange: analytics.trackBrandFontChange.bind(analytics),
        trackLogoUploadClick: analytics.trackLogoUploadClick.bind(analytics),

        // Team Management
        trackTeamInviteClick: analytics.trackTeamInviteClick.bind(analytics),
        trackTeamInviteSend: analytics.trackTeamInviteSend.bind(analytics),
        trackTeamRemoveClick: analytics.trackTeamRemoveClick.bind(analytics),
        trackTeamRoleChange: analytics.trackTeamRoleChange.bind(analytics),
        trackTeamResendInvite: analytics.trackTeamResendInvite.bind(analytics),

        // Opportunity Card
        trackOpportunityCardActionClick:
            analytics.trackOpportunityCardActionClick.bind(analytics),

        // Utility methods
        identifyUser: analytics.identifyUser.bind(analytics),
        setUserProperties: analytics.setUserProperties.bind(analytics),
        reset: analytics.reset.bind(analytics),
    }
}
